<template>
  <div class="sale-rank-box">
    <div>
      <span style="border-right:1px solid blue;width:15rem" class="trend-title">产品名称</span>
      <span style="border-right:1px solid blue;width:10rem" class="trend-title">去年销量</span>
      <span style="width:10rem" class="trend-title">今年销量</span>
      <!-- <el-button size="mini"  @click="addRank" style="margin-left:1rem" type="primary" icon="el-icon-plus"></el-button> -->
      <i @click="addRank" class="el-icon el-icon-circle-plus-outline f_green"></i>
    </div>
    <div v-for="(item,index) in rankDate" :key="index" class="sale-rank">
        <el-input show-word-limit type="text" maxlength="20" placeholder="请输入20以内文字" v-model="item.proName"></el-input>
        <el-input type="number" v-model="item.saleDataLast">
          <template slot="suffix">万元</template>
        </el-input>
        <el-input type="number" v-model="item.saleData">
          <template slot="suffix">万元</template>
        </el-input>
        <!-- <el-button @click="removeRank(item.id,index)" style="margin-left:1rem" type="primary" icon="el-icon-minus"></el-button> -->
        <i @click="removeRank(item.id,index)" class="el-icon el-icon-remove-outline f_red"></i>
      
    </div>
    <div class="last-save">
      <el-button :loading="rankLoading" size="small" @click="saveRank" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/apis/sale/sale'
export default {
  data(){
    return{
      rankLoading:false,//加载状态
      rankDate:[
        {proName:'',saleDataLast:'',saleData:''}
      ]
    }

  },
  mounted(){
    this.getRank()
  },
  methods:{
    //保存数据
    saveRank(){
      this.rankLoading = true
      api.saveOrder(this.rankDate).then(res=>{
        if(res.code==10000){
          this.rankLoading = false
          this.getRank()
          this.$message.success('保存成功');
        }else{
          this.$message.error(res.message);
          this.rankLoading = false
          return;
        }
      })
    },
    //获取数据
    getRank(){
      api.getOrder().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.rankDate = res.data
          }
        }
      })
    },
    //删除一行排名
    removeRank(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delOrder([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getRank()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.rankDate.splice(index,1)
      }
    },
    //增加一行排名
    addRank(){
      this.rankDate.push({proName:'',saleDataLast:'',saleData:''})
    },
  }
}
</script>
<style lang="less" scoped>
.sale-rank-box{ padding-top: 10px;
  .trend-title{ text-align: center;}
  i{ font-size: 1.2rem; font-weight: bold; margin-left: 1rem; vertical-align: middle;}
  .sale-rank{
    .el-input{ width: 10rem;}
    .el-input:nth-child(1){ width: 15rem;}
  }
}
</style>